import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent } from './FormContent';

export const CompanyActivitySection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="companyActivitySection"
      title={t('client.legal.companyActivity.title')}
    >
      <FormContent />
    </Section>
  );
};
